import { render, staticRenderFns } from "./AdviseStyleOne.vue?vue&type=template&id=79eb40ff&scoped=true&"
import script from "./AdviseStyleOne.vue?vue&type=script&lang=ts&"
export * from "./AdviseStyleOne.vue?vue&type=script&lang=ts&"
import style0 from "./AdviseStyleOne.vue?vue&type=style&index=0&id=79eb40ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79eb40ff",
  null
  
)

export default component.exports